import { PropsWithChildren, ReactNode } from 'react'
import { components } from 'react-select'
import { cn } from 'utils/style'

type ControlProps = PropsWithChildren<{
	icon: ReactNode
	label: string
	compact?: boolean
}>

const Control = ({ children, icon, label, compact = true, ...rest }: ControlProps) => {
	const Component = components.Control as any

	return (
		<Component {...rest}>
			{children}
			<span
				className={cn(
					'inline-flex h-9 items-center justify-center gap-2 text-sm font-medium text-foreground [&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0 [&>svg]:stroke-2',
					compact ? 'w-9 sm:w-auto sm:px-4' : 'w-full px-4'
				)}>
				{icon}
				<span className={cn(compact && 'hidden sm:inline')}>{label}</span>
			</span>
		</Component>
	)
}

export default Control
